import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import getLabel from './../../../../utils/labels';
import styles from './welcome.module.scss';
import analytics from '../../../../utils/segmentUtils';

class Welcome extends Component {
    componentDidMount() {
        analytics.page('Welcome Page')
    }

    render() {
        let { introductionData } = this.props;
        return (
            <div className={styles['welcome-page-wrapper']}>
                <div className={styles['welcome-container']}>
                    <div className={styles['title']}>
                        {getLabel('label_welcome')}
                    </div>
                    <div className={styles['info-text']}>
                        {introductionData.welcomePage.content}
                    </div>
                    <div className={styles.line}></div>
                    <Link to={this.props.nextUrl}>
                        <div className={styles['start-button-text']}>
                            {getLabel('label_welcome_start_button')}
                        </div>
                    </Link>
                </div>
            </div>
        )
    }
}

Welcome.propTypes = {
    timeData: PropTypes.object
};

Welcome.defaultProps = {
    timeData: {}
}

export default Welcome;


// WEBPACK FOOTER //
// /src/components/intro/pages/welcome/Welcome.js